export const videoPlayer = () => {
	
	let videoPlayers = document.querySelectorAll('.js__video-player');
	if(videoPlayers){
		videoPlayers.forEach((videoPlayer) => {
			for (var source in videoPlayer.children) {
				var videoSource = videoPlayer.children[source];
				if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
					videoSource.src = videoSource.dataset.src;
				}
			}
			videoPlayer.load();

			let videoPlayerToggle = document.querySelector('.js__toggle-video');
			videoPlayerToggle.addEventListener('click', (event) => {

				if(videoPlayer.paused){
					videoPlayer.play();
					videoPlayerToggle.classList.add('hidden');
				}else{
					videoPlayer.pause();
					videoPlayerToggle.classList.remove('hidden');	
					
				}
						
			});
		})
		

	}
}
